var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2, _circle, _circle2, _circle3, _rect, _rect2, _circle4, _circle5, _path7, _path8, _path9, _circle6, _circle7, _circle8, _rect3, _rect4, _circle9, _circle0, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _polyline, _path18, _path19, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Folha",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f43f5e;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#064e3b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m230.95,402.94c0,22.73,8.23,31.39,22.3,35.29l-.22,1.73c-13.27,0-30.27,1.6-38.04.39-.27-.04.27-.04,0,0-12.43,1.73-26.18-.39-39.25-.39l-.22-1.73c13.86-3.9,22.3-12.56,22.3-35.29v-76.21c0-23.17-7.14-31.39-20.57-35.07l.22-1.3c11.78,0,24.61,1.48,36.62,3.4.27.04.94.24.8,0-.13-.21,55.7-2.14,60.44-7.09h1.73c-.22,12.56-2.82,29.01-3.03,40.49h0c-1.29,0-2.42-.87-2.76-2.11-3.57-13.03-4.6-22.78-24.95-22.78-14.51,0-15.37,3.25-15.37,19.27v34.16c0,1.58,1.28,2.86,2.86,2.86h3.85c8.66.21,15.35-1.75,20.64-9.4.53-.76,1.4-1.21,2.33-1.21h.41c-.22,14.51-3.03,28.8-3.03,40.05h-1.52c-3.43-12.22-8.99-18.07-16.45-19.03-.14-.02-.29-.03-.43-.03h-5.8c-1.58,0-2.86,1.28-2.86,2.86v31.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m511.51,434.58c-37.89,0-62.57-29.45-62.57-72.75s24.9-78.59,66.03-78.59c37.67,0,62.57,29.44,62.57,72.74s-25.12,78.59-66.03,78.59Zm1.25-131.02c-18.62,0-25.29,18.01-25.29,51.35,0,49.15,10.91,57.65,26.29,57.65,18.84,0,25.03-16.51,25.03-49.64,0-48.71-10.44-59.36-26.03-59.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m641.76,369.55c6.25-4.69,34.46-29.15,34.46-46.47,0-19.27-17.93-30.53-31.13-30.53-2.17,0-3.25.65-3.9.87v103.71c0,22.73,8.44,31.39,22.52,35.29l-.22,1.73c-3.36,0-6.67-.16-9.95-.43-19.21-1.59-38.54-1.55-57.76.02-3.17.26-6.37.41-9.59.41l-.22-1.73c13.86-3.9,22.08-12.56,22.08-35.29v-72.1c0-25.76-8.01-34.86-22.73-38.97l.22-1.52c3.73.13,7.5.34,11.25.62,14.63,1.08,29.31.97,43.92-.25,2.99-.25,6.09-.37,9.56-.37,38.54,0,50.01,14.94,50.01,33.78,0,17.54-12.56,32.26-31.39,38.75,16.67,2.38,26.2,16.46,32.91,29.23,9.96,19.27,17.97,39.4,31.39,39.4,2.38,0,4.11-.22,7.36-2.6l.87,1.73c-12.05,13.95-18.62,10.61-31.61,10.61-19.05,0-31.39-11.47-40.92-37.02-6.93-18.4-27.14-28.87-27.14-28.87Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m951.67,289.74c2.6,0,1.51,45.03,1.51,45.03,0,0-1.44.11-1.73-.22-14.78-16.42-16.02-39.62-30.53-39.62-9.31,0-16.45,6.5-16.45,16.45,0,13.21,11.91,19.49,31.39,30.96,18.62,10.83,31.18,24.25,31.18,45.03,0,26.2-20.78,47.63-54.34,47.63-10.39,0-37.67-2.17-36.81-19.7,0,0,3.72-45.63,4.11-45.25,24.51,23.59,20.13,52.61,36.81,52.61,11.04,0,22.3-6.71,22.3-21.65s-10.39-20.57-21.87-26.85c-22.95-12.56-40.27-22.52-40.27-47.63,0-29.44,24.68-42.22,46.76-42.22,17.75,0,22.08,5.41,27.93,5.41Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1024.24,354.69c0,49.15,14.07,67.77,33.13,67.77,14.94,0,19.64-23.73,36.59-38.54.37-.32,1.95,0,1.95,0l-2.38,32.48c-1.3,16.02-20.78,17.75-37.46,17.75-44.17,0-71.23-29.23-71.23-72.53s28.8-78.16,69.93-78.16c19.7,0,28.36,5.41,33.99,5.41,2.81,0,7.36-1.08,8.23-5.41,0,0,4.27,46.02-6.5,54.56-.38.3-1.95-.22-1.95-.22-1.52-26.63-18.4-44.38-36.37-44.38-21,0-27.93,25.98-27.93,61.27Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1178.71,400.01c-7.26-5.29-29.1-5.83-35.94,0-2.71,2.31-4.76,4.04-4.76,4.04-2.17,6.06-3.25,10.83-3.25,14.51,0,8.01,4.55,11.47,11.91,13.86l-.22,1.51c-2.25,0-4.22-.1-5.98-.28-11.29-1.13-22.67-1.41-33.93-.02-1.51.19-3.06.3-4.69.3l-.22-1.51c13.64-3.46,18.41-9.09,25.76-28.36,10.61-27.81,46.76-124.06,46.76-124.06h1.51l40.27,117.35c8.23,23.6,10.83,31.18,23.82,35.07v1.51c-4.55,0-8.27-.16-11.7-.48-13.1-1.22-26.29-1.46-39.39-.21-4.7.45-9.42.69-13.86.69l-.22-1.51c7.36-2.38,11.26-5.85,11.26-13.64,0-3.68-.87-8.44-2.82-14.72,0,0-1.48-1.97-4.33-4.04Zm-32.91-18.26l31.29.75-15.27-46.21-16.02,45.47Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "379.86 455.14 366.86 455.14 370.86 252.14 377.24 252.14 379.86 455.14"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "374.24 266.14 363 244.87 385.48 244.87 374.24 266.14"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 330.86,
    cy: 267.14,
    r: 7.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 351.86,
    cy: 287.14,
    r: 7.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 319.36,
    cy: 304.64,
    r: 8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 332.53,
    y: 272.53,
    width: 2.17,
    height: 17.87,
    transform: "translate(-44.95 64.18) rotate(-10.3)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 352.07,
    y: 294.04,
    width: 2.45,
    height: 17.66,
    transform: "translate(-21.74 27.38) rotate(-4.31)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 337.36,
    cy: 327.64,
    r: 8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 310.36,
    cy: 282.64,
    r: 8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m321.36,297.64s15.5-2.5,20.5,2.5l3.51,3.73s-11.6-8.12-23.55-3.43l-.46-2.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m338.62,321.45s15.5-2.5,20.5,2.5l3.51,3.73s-11.6-8.13-23.55-3.43l-.46-2.8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m312.41,274.9s22.45,12.23,34.45,24.23c0,0,22,29,25,38l-1,13s-17-37-23-43c0,0-23.07-24.46-29.54-25.23l-5.91-7Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 418.36,
    cy: 245.64,
    r: 7.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 397.36,
    cy: 265.64,
    r: 7.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 429.86,
    cy: 283.14,
    r: 8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 406.67,
    y: 258.88,
    width: 17.87,
    height: 2.17,
    transform: "translate(85.52 622.39) rotate(-79.7)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 387.09,
    y: 280.14,
    width: 17.66,
    height: 2.45,
    transform: "translate(85.63 655.04) rotate(-85.69)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 411.86,
    cy: 306.14,
    r: 8
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 438.86,
    cy: 261.14,
    r: 8
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m427.86,276.14s-15.5-2.5-20.5,2.5l-3.51,3.73s11.6-8.12,23.55-3.43l.46-2.8Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m410.6,299.95s-15.5-2.5-20.5,2.5l-3.51,3.73s11.6-8.12,23.55-3.43l.46-2.8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m436.8,253.4s-22.45,12.23-34.45,24.23c0,0-22,29-25,38l1,13s17-37,23-43c0,0,23.07-24.46,29.54-25.23l5.91-7Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m450.05,168.73c-.06.05-.12.1-.19.16-2.76,2.3-6.47,2.5-9.73,4.01-3.77,1.74-8.62,1.06-14.77,2.74-11,3-11,14-24,19,0,0-11.74,5.86-26.5,5.99-14.76-.13-26.5-5.99-26.5-5.99-13-5-11-17-22-20-6.85-1.87-12.54-2.57-15.86-2.84-2.61-.21-5.11-1.17-7.2-2.76-.59-.45-1.14-.9-1.64-1.31-1.02-.86-2.57-.17-2.64,1.16-1.33,25.49,25.33,56.75,25.33,56.75,3,6,25,13,25,13,3.84.64,8.91,4.15,12.06,6.59,2.21,1.71,4.85,2.76,7.63,2.98s4.88.19,5.8.16c1.04.03,3.6.06,6.83-.25,2.21-.21,4.31-1.08,6.06-2.46,3.08-2.44,8.54-6.35,12.62-7.02,0,0,24-6,27-12,0,0,24.66-31.26,23.33-56.75-.07-1.33.38-2.02-.64-1.16Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m434.07,147.2c-2.67-.47-5.41-.48-8.1-.13-5.3.68-17.64,1.23-26.35-6.43,0,0-9.11-8.93-24.8-9.06v-.02c-.09,0-.17,0-.26,0-.09,0-.17,0-.26,0v.02c-15.69.13-24.8,9.06-24.8,9.06-9.03,7.94-21.97,7.05-26.91,6.35-1.77-.25-3.58-.29-5.36-.09-17.45,1.95-18.37,11.74-18.37,11.74,0,4.8,4.45,6.86,6.22,7.49.56.2,1.08.45,1.6.72,5.52,2.89,12.96,3.6,17.06,3.76,3.08.12,6.02,1.2,8.42,3.07,6.09,4.74,12.17,12.97,12.17,12.97,10.03,8.83,26.5,8.3,30.23,8.06,3.73.24,20.19.77,30.23-8.06,0,0,6.61-7.29,12.86-11.96,2.11-1.57,5.99-2.92,8.65-3.06,4.4-.23,13.55-2,19.09-5.27,0,0,.05-.01.14-.04,5.6-1.6,7.16-8.51,2.9-12.38-2.86-2.59-7.46-5.52-14.35-6.74Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m403.88,462.32c.06,1.55.35,8.54.87,15.68-2.33-3.68-14.63-23.29-17.87-21.66-9.59,4.77-3.2,19.83,2.79,29.39-6.5-4.16-11.04,11.26,7.67,21.57l-.26,2.42c-4.04,3.75-9.57,9.33-11.68,13.55-1.91.97-15.91,8.18-23.28,15.89l-5.67-1.9c12.88-15.67,20.16-20.63,23.54-26.13,2.23-3.64,6.25-14.52,2.94-19.87-2.02-3.27-6.4-2.95-6.86-2.68-.35.19-8.46,4.63-13.8,11.63-1.56.56-11.5,4.47-17.93,15.23-6.36,4.52-18.68,14.59-21.22,22.14-4.88,14.37-12.4,38.73-5.73,52.44-.73,11.17-.83,32.64,3.82,43.13,8.36,18.9,58.36,24.58,58.9,23.97.55-.63-9.76-35.26-3.39-45.43,6.27-10.02,38.28-36.64,41.59-42.04,3.38-5.45,6.98-45.51,6.22-50.91-.09-.72-.64,1.31,2.3-7.47,3.47-10.35,6.22-14.9,2.04-22.07-.93-1.59,13.48-20.34,5.76-22.93-1.97-.66-7.44-1.67-13.23,4.38-.56-3.47-4.46-28.45-7.55-30-4.27-2.14-13.6.04-9.96,21.68Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m416.42,539.53s3.64-10.45,7.19-20.85"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m434.41,466.86c-4.41-1.48-12.66-.32-19.31,15.13,0,0-10.63,17.06-13,24.12,0,0-3.73,3.13-7.7,7.07"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m392.89,548.2c.3-.88,24.04-24.84,28.91-32.04,4-5.92,3.84-18.2,6.11-26.47"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m405.74,482.17c.51,5.86,1.17,11.07,1.97,12.37"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "390.65 486.07 398.57 501.99 397.68 510.04"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m344.24,551.82s7.39-8.39,12.85-14.97"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m849.68,386.73c-2.16,19.49-11.69,35.29-30.31,35.29-14.94,0-16.46-11.26-16.46-24.9v-27.16c11.7-10.83,27.96-9.74,35.16-8.57,1.97.32,3.69-1.35,3.48-3.33-1.94-17.82-16.62-17.57-18.84-17.42-.18.01-.36.04-.53.08-7.54,1.77-14.09,7.78-19.26,14.41v-46.56c0-10.18,1.73-12.12,17.54-12.12,18.19,0,19.27,11.26,23.38,24.9h2.17c.22-11.47,2.81-27.93,3.03-40.49h-1.73c-9.76,4.2-35.37,5.59-50.07,6.34-6.31.32-12.62.14-18.9-.59-8.51-1-22.05-2.61-29.7-2.61l.16,1.84c13.42,3.68,20.57,11.91,20.57,35.07v76.21c0,23.17-7.14,31.61-20.57,35.29l5.97,1.14c11.26,0,25.14.54,29.83.54,10.94,0,41.06.05,48.63.05,18.84,0,16.02-1.3,18.19-47.42h-1.73Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1022.76,
    y: 444.55,
    width: 49,
    height: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.3602e9c4158e2f7416750078849122c0.svg";
export { ForwardRef as ReactComponent };